import { getWinnersReportJson } from '../../services/api/customerReportApi';
import {
    SET_WINNERS_REPORT_DATA,
    SET_WINNERS_REPORT_FILTERS,
    CLEAR_WINNERS_REPORT,
} from './actionTypes';
import { hideLoading, showLoading } from './loadingActions';
import { notifyError } from './notificationActions';

// Action creators
export const setWinnersReportData = (reportData, page, rowsPerPage) => ({
    type: SET_WINNERS_REPORT_DATA,
    reportData,
    page,
    rowsPerPage,
});

export const setWinnersReportFilters = (filters) => ({
    type: SET_WINNERS_REPORT_FILTERS,
    filters,
});

export const clearWinnersReport = () => ({
    type: CLEAR_WINNERS_REPORT,
});

// Thunk: search with new filters (resets to page 0)
export function searchWinnersReport(fromDate, toDate, options = {}) {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;
        const limit = options.limit || 10;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() =>
                dispatch(
                    setWinnersReportFilters({
                        fromDate,
                        toDate,
                        gigyaId: options.gigyaId || '',
                        eventType: options.eventType || '',
                    })
                )
            )
            .then(() =>
                getWinnersReportJson(
                    market,
                    category,
                    brand,
                    fromDate,
                    toDate,
                    {
                        ...options,
                        start: 0,
                        limit,
                    }
                )
            )
            .then((data) => dispatch(setWinnersReportData(data, 0, limit)))
            .catch((error) =>
                dispatch(notifyError('Error!', 'Unable to fetch report'))
            )
            .finally(() => dispatch(hideLoading()));
    };
}

// Thunk: fetch a specific page (uses stored filters)
export function fetchWinnersReportPage(page, rowsPerPage) {
    return function (dispatch, getState) {
        const { auth, winnersReport } = getState();
        const { market, category, brand } = auth?.user;
        const { filters } = winnersReport;
        const start = page * rowsPerPage;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() =>
                getWinnersReportJson(
                    market,
                    category,
                    brand,
                    filters.fromDate,
                    filters.toDate,
                    {
                        gigyaId: filters.gigyaId || undefined,
                        eventType: filters.eventType || undefined,
                        start,
                        limit: rowsPerPage,
                    }
                )
            )
            .then((data) =>
                dispatch(setWinnersReportData(data, page, rowsPerPage))
            )
            .catch((error) =>
                dispatch(notifyError('Error!', 'Unable to fetch report'))
            )
            .finally(() => dispatch(hideLoading()));
    };
}
